import "./App.scss";
import { useState } from "react";
import { BrowserRouter } from "react-router-dom";
import { Routes, Route } from "react-router-dom";

// Components
import Layout from "./components/Layout/Layout";
import WelcomeWindow from "./components/Windows/WelcomeWindow/WelcomeWindow";
import AboutMeWindow from "./components/Windows/AboutMeWindow/AboutMeWindow";
import WorkWindow from "./components/Windows/WorkWindow/WorkWindow";
import SideProjectWindow from "./components/Windows/SideProjectWindow/SideProjectWindow";
import LabWindow from "./components/Windows/LabWindow/LabWindow";
import GuestBookWindow from "./components/Windows/GuestBookWindow/GuestBookWindow";
import BlogWindow from "./components/Windows/BlogWindow/BlogWindow";
import BlogList from "./components/Windows/BlogWindow/BlogList/BlogList";
import BlogPost from "./components/Windows/BlogWindow/BlogPost/BlogPost";
import MusicWindow from "./components/Windows/MusicWindow/MusicWindow";
import ErrorWindow from "./components/Windows/ErrorWindow/ErrorWindow";

// Context
import { CookieProvider } from "./context/CookieContext";

// SCSS
import "./styles/style.scss";

function App() {
  // Language
  const browserLang = navigator.language.split("-")[0];
  const initialLang = ["ko", "ja", "en"].includes(browserLang)
    ? browserLang
    : "en";

  const [language, setLanguage] = useState(initialLang);

  return (
    <CookieProvider>
      <BrowserRouter>
        <Routes>
          <Route
            path="/"
            element={<Layout language={language} setLanguage={setLanguage} />}
          >
            <Route
              path="/welcome"
              element={<WelcomeWindow lang={language} />}
            />
            <Route
              path="/about-me"
              element={<AboutMeWindow lang={language} />}
            />
            <Route path="/work" element={<WorkWindow lang={language} />} />
            <Route path="/side-project" element={<SideProjectWindow />} />
            <Route path="/lab" element={<LabWindow lang={language} />} />
            <Route path="/guest-book" element={<GuestBookWindow />} />
            <Route path="/music" element={<MusicWindow lang={language} />} />

            <Route path="/blog" element={<BlogWindow lang={language} />}>
              <Route index element={<BlogList lang={language} />} />
              <Route path=":id" element={<BlogPost lang={language} />} />
            </Route>

            <Route path="*" element={<ErrorWindow lang={language} />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </CookieProvider>
  );
}

export default App;
